/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { Model } from "../utils/json-api";
import { Company } from "./Company.model";

export class User implements Model {
    static get TYPE() {
        return "User";
    }

    id?: string;
    createdAt?: string;

    title?: "m" | "mme";
    email?: string;
    firstname?: string;
    lastname?: string;

    phone?: string;

    team?: string;

    // Uniquement AG2R
    vendorCode?: string;                // AG2R Code vendeur
    counsellorCode?: string;            // LA MONDIALE Code conseiller

    // Uniquement partenaires apporteur
    bringerCode?: string;               // Code apporteur

    // Tout le monde
    agencyCode?: string;                // Code agence

    // Uniquement pour Mutuelle de Poitiers
    agentCode?: string;                 // Code agent
    nsoCode?: string;                   // Code NSO

    profileCompleted?: boolean;

    avatarUrl?: string;
    manager?: User;

    company?: Company;

    advisors?: User[];
}



// WEBPACK FOOTER //
// ./src/models/User.model.ts